import { MUPDF_LOADED } from '#pplx/frontend/pdf-worker/index.js';
import * as Comlink from 'comlink';
const THUMBNAIL_SCALE = 0.5;
export function generatePdfThumbnail(file) {
    return new Promise((resolve) => {
        const worker = new Worker('/pdf-worker.js', { type: 'module' });
        const mupdfWorker = Comlink.wrap(worker);
        worker.addEventListener('message', async (event) => {
            if (event.data !== MUPDF_LOADED)
                return;
            try {
                const arrayBuffer = await file.arrayBuffer();
                await mupdfWorker.loadDocument(arrayBuffer);
                const pngData = await mupdfWorker.renderPageAsImage(0, THUMBNAIL_SCALE);
                const url = URL.createObjectURL(new Blob([pngData], { type: 'image/png' }));
                resolve(url);
            }
            catch {
                resolve(null);
            }
            finally {
                worker.terminate();
            }
        });
        worker.addEventListener('error', () => {
            worker.terminate();
            resolve(null);
        });
    });
}
//# sourceMappingURL=pdf.js.map